<template>
  <div v-if="grid.length" class="multicriteria-container">
    <div style="display: flex; justify-content: space-around; padding: 10px 10px 0 5px">
      <select id="multicriteria-select-type" style="width: 100%; margin: 0 5px 0 5px"></select>
      <div class="btn-group btn-export" v-if="hasExportButton">
        <a href="#" class="btn btn-xs btn-default" style="height: 34px; line-height: 25px;" :title="`Exportar ${title}`"
          @click="exportData">
          <i class="fa fa-download"></i>
        </a>
      </div>
    </div>
    <div>
      <div class="infoboard-title">
        {{ title }}
      </div>
      <div class="list-colors">
        <ul>
          <li v-for="(v, k) of colors" :key="`colors-${k}`">
            <span class="circle" :style="{ 'background-color': v }"></span>
            {{ evaluations[k] }}
          </li>
        </ul>
      </div>
      <div class="k-grid k-widget k-display-block multicriteria-table">
        <table v-for="(row, idx) in data" :key="`row-${idx}`">
          <thead class="k-grid-header">
            <tr>
              <th :colspan="row.data.columns.length" class="k-header column-center">
                {{ row.theme }}
              </th>
            </tr>
            <tr>
              <th v-for="column in row.data.columns" :key="column.field" class="k-header column-center"
                :style="{ width: column.width }">
                {{ column.title }}
              </th>
            </tr>
          </thead>
          <tbody style="font-size: 0.9em">
            <tr v-for="(item, itemIdx) in row.data.dataSource" :key="`data-${itemIdx}`" class="no-hover-last-td">
              <td v-for="(column, columnIdx) in row.data.columns"
                v-show="columnIdx !== (row.data.columns.length - 1) || columnIdx === (row.data.columns.length - 1) && itemIdx === 0"
                :rowspan="columnIdx === (row.data.columns.length - 1) && itemIdx === 0 ? row.data.dataSource.length : undefined"
                :key="`data-${itemIdx}-${columnIdx}`">
                <div class="column-evaluation" v-if="column.field === 'evaluation'"
                  :title="evaluations[Math.round(item[column.field])]">
                  <span class="circle" :style="{ 'background-color': colors[Math.round(item[column.field])] }">
                  </span>
                  {{ item[column.field] }}
                </div>
                <div v-else-if="column.field === 'kpi' && item['kpiDescription']" style="display: flex; gap: 10px">
                  <i :id="`icon_${item['kpiId']}`" class="fa fa-info" style="margin-top: 4px; cursor: pointer;"></i>
                  <span>{{ item[column.field] }}</span>
                </div>
                <div v-else>
                  {{ format(item[column.field], column.format) }}
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="idx === (data.length - 1)">
            <tr style="font-weight: bold;">
              <td :colspan="data[0].data.columns.length - 1" class="k-header column-center">
                Score
              </td>
              <td class="k-header column-center">
                {{ data[0].data.dataSource[0].score }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import numeral from 'numeral';
import api from '../../../../scripts/api';

export default {
  name: 'dashboard-multicriteria',

  props: {
    id: {
      type: Number
    },
    title: {
      type: String
    },
    filename: {
      type: String
    },
    buttons: {
      type: Object
    },
    grid: {
      type: Array
    },
    multicriteriaTypes: {
      type: Array
    },
    tooltip: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    hasExportButton() {
      return this.buttons && this.buttons.export && _.isFunction(this.buttons.export);
    },

    types() {
      return this.multicriteriaTypes.filter(x => x.visible);
    }
  },

  data() {
    return {
      colors: {
        1: '#F3A3A3',
        2: '#FFC000',
        3: '#FFFF00',
        4: '#92D050',
        5: '#51B7FD'
      },
      evaluations: {
        1: 'Muito Baixo',
        2: 'Baixo',
        3: 'Regular',
        4: 'Alto',
        5: 'Muito Alto'
      },
      data: this.grid,
      typeSelected: null
    };
  },

  watch: {},

  mixins: [],

  methods: {
    onSelectTypes(event) {
      this.typeSelected = event.sender.value();

      api.afterSales.get.multicriteria.getCalculateds(this.id, event.sender.value()).then(response => {
        const data = _(response.tables)
          .keys()
          .map(theme => ({
            data: response.tables[theme],
            theme
          }))
          .value();

        this.data = data;
        this.loadPopover();
      });
    },

    exportData() {
      const nameSelect = _.kebabCase(this.types.find(x => x.value === parseInt(this.typeSelected)).name);
      this.$emit('export', `${this.filename}`, this.typeSelected);
    },

    format(value, format) {
      if (format) {
        return numeral(value).format(format);
      }

      return value;
    },

    loadPopover() {
      this.$nextTick(() => {
        this.data.forEach(x => {
          x.data.dataSource.forEach(y => {
            if (y.kpiDescription) {
              $(`#icon_${y.kpiId}`).popover({
                html: true,
                trigger: 'hover',
                placement: 'left',
                container: 'body',
                title: y.kpi,
                content: y.kpiDescription
              }).on("show.bs.popover", function () {
                $(this).data("bs.popover").tip().css("max-width", "500px");
              });
            }
          });
        });
      });
    }
  },

  mounted() {
    this.loadPopover();
    this.typeSelected = this.types[0].value;

    this.$nextTick(() => {
      const dropdown = $('#multicriteria-select-type')
        .kendoDropDownList({
          autoBind: true,
          filter: 'contains',
          dataTextField: "name",
          dataValueField: "value",
          dataSource: this.types,
          change: this.onSelectTypes
        }).data("kendoDropDownList");

      if (this.types.length === 1) {
        dropdown.enable(false);
      }
    });
  },

  destroyed() {
  },
};
</script>

<style lang="scss" scoped>
.column-center {
  text-align: center !important;
}

.multicriteria-container {
  display: flex;
  flex-direction: column;

  &>.btn-export {
    align-self: end;
    margin-right: 10px;
    position: relative;
    top: 10px;
  }
}

.column-evaluation {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.circle {
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.list-colors ul {
  padding: 0;
  list-style: none;
  display: flex;
  font-size: 0.8em;
  gap: 10px;
  justify-content: center;

  &>li {
    display: flex;
    align-items: center;
    gap: 3px
  }
}

.multicriteria-table {
  margin: 0 8px 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/dashboards/components/dashboard-multicriteria/dashboard-multicriteria.component.vue